<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>Client Detail</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">

				<md-table>
					<md-table-row>
						<md-table-cell style="width: 40%;">Client ID</md-table-cell>
						<md-table-cell style="width: 5px">:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.hash_id).length > 0">{{client.hash_id}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>Name</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.name).length > 0">{{client.name}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>Khmer Name</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.name_khmer).length > 0">{{client.name_khmer}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>Date of Birth</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.dob).length > 0">{{client.dob}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>Gender</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.gender).length > 0">{{config.getGender(client.gender)}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>

					<md-table-row>
						<md-table-cell>Document Link</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell><a :href="client.doc_url" target="_blank">Open</a></md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<!-- <h3>Client Detail</h3> -->
				<md-table>
					<md-table-row>
						<md-table-cell>Occupation</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.occupation).length > 0">{{client.occupation}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>Phone Number</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.phone).length > 0">{{client.phone}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ID Card Number</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.id_card).length > 0">{{client.id_card}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>Address</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.address).length > 0">{{client.address}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>Remark</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.note).length > 0">{{client.note}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>Created Date</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.created_date).length > 0">{{config.datelify(client.created_date)}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<!-- <div class="md-layout-item md-small-size-100 md-size-50">
				<h3>Loan Detail</h3>
				<md-table>
					<md-table-row>
						<md-table-cell style="width: 40%;">Total Loan Amount</md-table-cell>
						<md-table-cell style="width: 5px">:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.name).length > 0">$5,000.00</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>Total Loan</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.name_khmer).length > 0">2 Loans</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>Total payment</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.phone).length > 0">$6,300.00</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>Remaining balance</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.note).length > 0">$4,725.00</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div> -->
			<div class="md-layout-item md-small-size-100 md-size-100" v-if="guaranteeList.length > 0">
				<h3>Loan Guarantee</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<md-table v-if="guaranteeList.length > 0">
					<md-table-row>
						<md-table-head>N.O</md-table-head>
						<md-table-head>Guarantee Date</md-table-head>
						<md-table-head>Client</md-table-head>
						<md-table-head>Loan ID</md-table-head>
						<md-table-head>Loan Amount</md-table-head>
						<md-table-head>Status</md-table-head>
						<md-table-head>Action</md-table-head>
					</md-table-row>

					<md-table-row v-for="(guarantee, index) in guaranteeList">
						<md-table-cell>{{ index + 1 }}</md-table-cell>
						<md-table-cell>{{ config.datelify(guarantee.start_date) }}</md-table-cell>
						<md-table-cell><b>CID: {{ guarantee.client_hash_id }}</b><br>{{guarantee.name}}</md-table-cell>
						<md-table-cell>{{ guarantee.loan_hash_id }}</md-table-cell>
						<md-table-cell>{{ config.moneylify(guarantee.amount) }}</md-table-cell>
						<md-table-cell>
							<span class="active" v-if="guarantee.status == 'act'">{{config.getStatus(guarantee.status)}}</span>
							<span class="late" v-if="guarantee.status == 'fin'">{{config.getStatus(guarantee.status)}}</span>
						</md-table-cell>
						<md-table-cell>
							<router-link :to="'/loans/detail/' + guarantee.loan_hash_id">
								<md-button class="md-just-icon md-simple md-success">
									<md-icon>visibility</md-icon>
									<md-tooltip md-direction="top">View loan information</md-tooltip>
								</md-button>
							</router-link>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>

			<div class="md-layout-item md-small-size-100 md-size-100" v-if="loanList.length > 0">
				<h3>Loan History</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<md-table v-if="loanList.length > 0">
					<md-table-row>
						<md-table-head>N.O</md-table-head>
						<md-table-head>Loan Date</md-table-head>
						<md-table-head>Loan ID</md-table-head>
						<md-table-head>Loan Amount</md-table-head>
						<md-table-head>Monthly Payment</md-table-head>
						<md-table-head>Next Payment</md-table-head>
						<md-table-head>Status</md-table-head>
						<md-table-head>Action</md-table-head>
					</md-table-row>

					<md-table-row v-for="(loan, index) in loanList">
						<md-table-cell>{{ index + 1 }}</md-table-cell>
						<md-table-cell>{{ config.datelify(loan.start_date) }}</md-table-cell>
						<md-table-cell>{{ loan.hash_id }}</md-table-cell>
						<md-table-cell>{{ config.moneylify(loan.amount) }}</md-table-cell>
						<md-table-cell>{{ config.moneylify(loan.monthly_payment) }}</md-table-cell>
						<md-table-cell>
							<span v-if="loan.total_paid == loan.term || loan.status == 'fin'" class="active">Not
								Available</span>
							<span class="late"
								v-else-if="String(loan.next_payment).length >0 && config.timelify(loan.next_payment) == 'Late'">{{config.datelify(loan.next_payment)}}</span>
							<span class="active"
								v-else-if="String(loan.next_payment).length >0">{{config.datelify(loan.next_payment)}}
								({{config.timelify(loan.next_payment)}})</span>
						</md-table-cell>
						<md-table-cell>
							<span class="active" v-if="loan.status == 'act'">{{config.getStatus(loan.status)}}</span>
							<span class="late" v-if="loan.status == 'fin'">{{config.getStatus(loan.status)}}</span>
						</md-table-cell>
						<md-table-cell>
							<router-link :to="'/loans/detail/' + loan.hash_id">
								<md-button class="md-just-icon md-simple md-success">
									<md-icon>visibility</md-icon>
									<md-tooltip md-direction="top">View loan information</md-tooltip>
								</md-button>
							</router-link>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
		</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {

			// this.getLocation();
			// this.getSettings();
			this.getClient();
			// this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				client: {
					hash_id: "",
					name: "",
					name_khmer: "",
					phone: "",
					note: "",
					doc_url: "",
					gender: "",
					created_date: ""
				},
				loanList: [],
				guaranteeList: []

			}
		},
		methods: {
			getClient() {
				this.$http.get(this.config.api + "/admin/client/get/" + this.$route.params.hash_id).then(data => {
					this.client = data.body.data
					this.loaded = true;
				})
				this.$http.get(this.config.api + "/admin/loan/get/client/" + this.$route.params.hash_id).then(data => {
					this.loanList = data.body.data
				})
				this.$http.get(this.config.api + "/admin/client/get_loan_guarantee/" + this.$route.params.hash_id).then(data => {
					this.guaranteeList = data.body.data;
				})
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Clients/Detail.vue